/* Memorigin: prices shown in the visitor's currency, checkout stays in the shop currency (HKD).
   Rates: Shopify's daily file (cdn.shopify.com/s/javascripts/currencies.js, relative to USD).
   Cart display estimates follow the selected currency; actual Shopify payment remains HKD. */
(function () {
  if (window.__mgCurLoaded) return;
  window.__mgCurLoaded = 1;

  var cfg = window.MG_CUR || {};
  var BASE = cfg.base || 'HKD';
  var DEFAULT = 'USD';
  var LIST = ["HKD","USD","GBP","CAD","EUR","CHF","CNY","TWD","JPY","SGD","MYR","KRW","THB","AUD","NZD","INR","IDR","PHP","VND","AED","SAR","QAR","KWD","BHD","OMR","SEK","NOK","DKK","PLN","CZK","HUF","RON","TRY","BRL","MXN","ZAR","ILS","RUB","PKR","BDT","LKR","EGP","NGN","KES","ARS","CLP","COP","PEN","ISK"];
  var BY_COUNTRY = {"HK":"HKD","MO":"HKD","US":"USD","GB":"GBP","CN":"CNY","TW":"TWD","JP":"JPY","SG":"SGD","MY":"MYR","KR":"KRW","TH":"THB","AU":"AUD","CA":"CAD","CH":"CHF","LI":"CHF","NZ":"NZD","IN":"INR","ID":"IDR","PH":"PHP","VN":"VND","AE":"AED","SA":"SAR","QA":"QAR","KW":"KWD","BH":"BHD","OM":"OMR","SE":"SEK","NO":"NOK","SJ":"NOK","DK":"DKK","FO":"DKK","GL":"DKK","PL":"PLN","CZ":"CZK","HU":"HUF","RO":"RON","TR":"TRY","BR":"BRL","MX":"MXN","ZA":"ZAR","IL":"ILS","RU":"RUB","PK":"PKR","BD":"BDT","LK":"LKR","EG":"EGP","NG":"NGN","KE":"KES","AR":"ARS","CL":"CLP","CO":"COP","PE":"PEN","IS":"ISK","AT":"EUR","BE":"EUR","BG":"EUR","HR":"EUR","CY":"EUR","EE":"EUR","FI":"EUR","FR":"EUR","DE":"EUR","GR":"EUR","IE":"EUR","IT":"EUR","LV":"EUR","LT":"EUR","LU":"EUR","MT":"EUR","NL":"EUR","PT":"EUR","SK":"EUR","SI":"EUR","ES":"EUR","AD":"EUR","MC":"EUR","SM":"EUR","VA":"EUR","ME":"EUR","XK":"EUR","AX":"EUR","GF":"EUR","GP":"EUR","MQ":"EUR","RE":"EUR","YT":"EUR","BL":"EUR","MF":"EUR","PM":"EUR","EC":"USD","PA":"USD","PR":"USD","GU":"USD","VI":"USD","AS":"USD","MP":"USD","TC":"USD","VG":"USD"};
  var SYMBOL = { HKD: 'HK$', USD: 'US$', GBP: '£', CAD: 'CA$', EUR: '€', CHF: 'CHF ', CNY: 'CN¥', TWD: 'NT$', JPY: '¥', SGD: 'S$', MYR: 'RM', KRW: '₩', THB: '฿', AUD: 'A$', NZD: 'NZ$', INR: '₹' };
  var KEY = 'mgCurrency';
  /* an HKD price as the theme prints it: HK$49,800.00 or HK$ 49,800 */
  var MONEY = /HK\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)/g;
  var SKIP = 'script,style,noscript,textarea,input,select,option,[data-mg-no-convert]';

  var rates = null, current = BASE;

  function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }

  function fmt(amount, code) {
    var n = Math.round(amount);
    var s = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (SYMBOL[code] || code + ' ') + s;
  }
  function convert(hkd, code) {
    if (!rates || !rates[BASE] || !rates[code]) return null;
    return hkd * rates[BASE] / rates[code];
  }

  /* wrap each HKD price once, remembering the original, then show it in the chosen currency */
  function wrap(root) {
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('HK$') < 0) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || p.closest(SKIP) || p.closest('.mg-money')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var text = n.nodeValue, frag = document.createDocumentFragment(), last = 0;
      text.replace(MONEY, function (m, num, idx) {
        if (idx > last) frag.appendChild(document.createTextNode(text.slice(last, idx)));
        var span = document.createElement('span');
        span.className = 'mg-money';
        span.setAttribute('data-hkd', num.replace(/,/g, ''));
        span.setAttribute('data-orig', m);
        span.textContent = m;
        frag.appendChild(span);
        last = idx + m.length;
        return m;
      });
      if (last === 0) return;
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }

  function paint(root) {
    var scope = root || document;
    function find(selector) {
      var found = Array.from(scope.querySelectorAll(selector));
      if (scope.nodeType === 1 && scope.matches(selector)) found.unshift(scope);
      return found;
    }
    var effective = current !== BASE && rates && convert(1, current) != null ? current : BASE;
    find('[data-mg-display-currency]').forEach(function (l) { if (l.textContent !== effective) l.textContent = effective; });
    find('.mg-money').forEach(function (s) {
      var want = s.getAttribute('data-orig');
      if (current !== BASE && rates) {
        var v = convert(parseFloat(s.getAttribute('data-hkd')), current);
        if (v != null) want = fmt(v, current);
      }
      if (s.textContent !== want) s.textContent = want;
      /* The native loading overlay must show the same display price, not stale HKD. */
      var host = s.parentElement;
      if (host && host.tagName === 'TEXT-COMPONENT' && host.hasAttribute('value') && host.getAttribute('value') !== want) host.setAttribute('value', want);
    });
    find('[data-mg-cur-label]').forEach(function (l) { if (l.textContent !== effective) l.textContent = effective; });
    find('[data-mg-cur]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-mg-cur') === current); });
    if (!root) document.documentElement.classList.toggle('mg-cur-foreign', effective !== BASE);
  }

  function choose(code, remember) {
    if (LIST.indexOf(code) < 0) code = DEFAULT;
    current = code;
    if (remember) store(code);
    paint();
  }

  function loadRates(done) {
    if (window.Currency && window.Currency.rates) { rates = window.Currency.rates; return done(); }
    var s = document.createElement('script');
    s.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
    s.async = true;
    s.onload = function () { rates = (window.Currency && window.Currency.rates) || null; done(); };
    s.onerror = function () { rates = null; done(); };
    document.head.appendChild(s);
  }

  function start() {
    wrap(document.body);
    /* prices the theme redraws later (variant change, recommendations, quick view) */
    /* only real page changes count; our own repainting of a price never triggers another round */
    var pending = new Set(), queued = false;
    function inOwn(node) {
      var el = node.nodeType === 1 ? node : node.parentElement;
      return !!(el && el.closest && el.closest('.mg-money,[data-mg-cur-label],[data-mg-display-currency]'));
    }
    function enqueue(node) {
      var el = node.nodeType === 1 ? node : node.parentElement;
      if (el && !inOwn(el)) pending.add(el);
    }
    var obs = new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (inOwn(m.target)) return;
        if (m.type === 'characterData') { enqueue(m.target); return; }
        m.addedNodes.forEach(enqueue);
      });
      if (!pending.size || queued) return;
      queued = true;
      requestAnimationFrame(function () {
        var roots = pending; pending = new Set(); queued = false;
        roots.forEach(function (el) {
          if (!el.isConnected) return;
          for (var parent = el.parentElement; parent; parent = parent.parentElement) {
            if (roots.has(parent)) return;
          }
          // Ignore ordinary carousel counters/reveals and detached measuring probes.
          if (el.textContent.indexOf('HK$') < 0 && !el.matches('.mg-money,[data-mg-cur-label],[data-mg-display-currency]') && !el.querySelector('.mg-money,[data-mg-cur-label],[data-mg-display-currency]')) return;
          wrap(el);
          // Only changed content is repainted; moving one card no longer scans all prices.
          paint(el);
        });
        obs.takeRecords();
      });
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mg-cur]');
      if (b) { e.preventDefault(); choose(b.getAttribute('data-mg-cur'), true); var d = b.closest('[data-mg-loc]'); if (d) d.removeAttribute('open'); return; }
      document.querySelectorAll('[data-mg-loc][open]').forEach(function (d) {
        var group = d.closest('.mg-drawer-selectors');
        if (!d.contains(e.target) && !(group && group.contains(e.target))) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('[data-mg-loc][open]').forEach(function (d) { d.removeAttribute('open'); });
    });

    loadRates(function () {
      var saved = stored();
      if (saved && LIST.indexOf(saved) >= 0) return choose(saved, false);
      /* first visit: the visitor's own currency, from the country Shopify detects */
      /* Failed/unknown visitor-country detection defaults to USD. */
      choose(DEFAULT, false);
      fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
          choose(BY_COUNTRY[c] || DEFAULT, false);
        })
        .catch(function () { choose(DEFAULT, false); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
